import { JobItem } from 'domains/workspaceDomain';
import { PDF_TEMPLATE_ENUM } from 'domains/workspaceDomain';
import workspaceService from 'services/jobService';
import { PDFLink } from 'components/RevxPDFLink';
import { TFuncKey, useTranslation } from 'react-i18next';
import CardInfoPDFLinks from './CardInfoPDFLinks';
import useJobCardInfo from '../../hooks/useJobCardInfo';

const {
  PURCHASE_ORDER,
  JOB_TICKET_REVSHOP,
  PACKING_SLIP_REVSHOP,
  PACKING_SLIP_SUPPLIER,
  JOB_TICKET_SUPPLIER,
} = PDF_TEMPLATE_ENUM;

type CardInfoPDFsProps = {
  data: JobItem;
};

const getPDFLink = (data: JobItem, template: PDF_TEMPLATE_ENUM) => {
  return workspaceService.getPdfLink({
    jobId: data.id,
    jobConfigId: data.quoteId,
    template,
  });
};

const CardInfoPDFs = ({ data }: CardInfoPDFsProps) => {
  const { t } = useTranslation();
  const { isInternalJob, hasOperator, hasProducer } = useJobCardInfo(data);

  const getPDFLinkDom = (template: PDF_TEMPLATE_ENUM) => {
    const tKeyMap: { [key: string]: TFuncKey } = {
      [PURCHASE_ORDER]: 'workspace.pdfTitle.po',
      [JOB_TICKET_REVSHOP]: 'workspace.pdfTitle.jobTicket',
      [PACKING_SLIP_REVSHOP]: 'workspace.pdfTitle.packingSlip',
      [PACKING_SLIP_SUPPLIER]: 'workspace.pdfTitle.packingSlip',
      [JOB_TICKET_SUPPLIER]: 'workspace.pdfTitle.jobTicket',
    };
    return (
      <PDFLink
        title={t(tKeyMap[template]) as string}
        link={getPDFLink(data, template)}
      />
    );
  };
  return (
    <div className="card-pdfs" style={{ marginTop: 12 }}>
      {hasOperator && (
        <>
          <div className="card-pdf-item">{getPDFLinkDom(PURCHASE_ORDER)}</div>
          <div className="card-pdf-item">
            {getPDFLinkDom(JOB_TICKET_REVSHOP)}
          </div>
          <div className="card-pdf-item">
            {getPDFLinkDom(PACKING_SLIP_REVSHOP)}
          </div>
        </>
      )}
      {hasProducer && isInternalJob && (
        <>
          <div className="card-pdf-item">
            {getPDFLinkDom(JOB_TICKET_SUPPLIER)}
          </div>
          <div className="card-pdf-item">
            {getPDFLinkDom(PACKING_SLIP_SUPPLIER)}
          </div>
          <CardInfoPDFLinks {...data} />
        </>
      )}
      {hasProducer && !isInternalJob && (
        <>
          <div className="card-pdf-item">{getPDFLinkDom(PURCHASE_ORDER)}</div>
          <div className="card-pdf-item">
            {getPDFLinkDom(JOB_TICKET_REVSHOP)}
          </div>
          <div className="card-pdf-item">
            {getPDFLinkDom(PACKING_SLIP_SUPPLIER)}
          </div>
        </>
      )}
    </div>
  );
};

export default CardInfoPDFs;
